var _rect, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagFr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 25",
    width: "1em",
    height: "1em",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 24.118,
    rx: 5,
    fill: "#D8D8D8"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 25
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 24.118,
    rx: 5,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 23.914h40.936V0H0v23.914z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 30v-41h-14v41h14z",
    fill: "#05268F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5 30v-41h-14v41h14z",
    fill: "#DA3F41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFr);
export default __webpack_public_path__ + "static/media/flag_fr.5d9db55fefbdb9ef34baee3c5e1b0b80.svg";
export { ForwardRef as ReactComponent };